import merge from 'lodash.merge';
var Orientation;
(function (Orientation) {
    Orientation["HORIZONTAL"] = "h";
    Orientation["VERTICAL"] = "v";
    Orientation["UNKNOWN"] = "";
})(Orientation || (Orientation = {}));
function getBrowserOrientaton(thisWindow) {
    if (thisWindow.matchMedia) {
        return thisWindow.matchMedia('(orientation: portrait)').matches
            ? Orientation.VERTICAL
            : Orientation.HORIZONTAL;
    }
    return Orientation.UNKNOWN;
}
export class GlobalTrackingManagerV1 {
    constructor(environmentData, provider, breakPoints, window, navigationData, myDealerTracking) {
        this.environmentData = environmentData;
        this.provider = provider;
        this.breakPoints = breakPoints;
        this.window = window;
        this.navigationData = navigationData;
        this.myDealerTracking = myDealerTracking;
        this.breakPoints.sort((bp1, bp2) => bp1 - bp2);
    }
    track(eventAction, event, contextualData) {
        const eventInfo = Object.assign({ eventAction, pageId: this.getPageId() }, this.navigationData());
        const globalEvent = {
            environment: this.environmentData,
            user: this.createUserData(),
            eventInfo
        };
        const fullContextualData = createFullContextualData(contextualData);
        let finalEvent = this.myDealerTracking
            ? merge(event, globalEvent, this.myDealerTracking.getMyDealerTrackingPayloadForUserSection())
            : merge(event, globalEvent);
        if (fullContextualData === null || fullContextualData === void 0 ? void 0 : fullContextualData.event) {
            finalEvent = merge(finalEvent, fullContextualData.event);
        }
        this.provider.push(finalEvent);
    }
    getPageId() {
        return `${this.window.location.host}${this.window.location.pathname}`;
    }
    createUserData() {
        return {
            browserResolutionBreakpoint: this.getBreakpoint(),
            browserResolutionHeight: this.window.screen.height.toString(),
            browserResolutionOrientation: getBrowserOrientaton(this.window),
            browserResolutionWidth: this.window.screen.width.toString()
        };
    }
    getBreakpoint() {
        // @ts-ignore
        if (this.window.matchMedia) {
            const matchingBps = this.breakPoints.filter((bp, idx) => {
                if (idx === this.breakPoints.length - 1) {
                    return this.matchMediaQuery(bp);
                }
                if (this.matchMediaQuery(bp, this.breakPoints[idx + 1])) {
                    return true;
                }
                return false;
            });
            if (matchingBps.length <= 0) {
                return '0';
            }
            return String(matchingBps[0]);
        }
        return '';
    }
    matchMediaQuery(minWidth, maxWidth) {
        if (!maxWidth) {
            return this.window.matchMedia(`screen and (min-width: ${minWidth}px)`)
                .matches;
        }
        return this.window.matchMedia(`screen and (max-width: ${maxWidth}px) and (min-width: ${minWidth}px)`).matches;
    }
}
export class ConsumerTrackingManagerV1Impl {
    constructor(delegate, featureAppService, consumerName) {
        this.delegate = delegate;
        if (featureAppService && consumerName) {
            this.featureApp =
                featureAppService.featureAppConfigurations[consumerName];
        }
    }
    track(action, event) {
        var _a, _b, _c, _d;
        if (!((_c = (_b = (_a = this.contextualEventData) === null || _a === void 0 ? void 0 : _a.event) === null || _b === void 0 ? void 0 : _b.environment) === null || _c === void 0 ? void 0 : _c.featureAppId) &&
            ((_d = this.featureApp) === null || _d === void 0 ? void 0 : _d.trackingId)) {
            const newContextualEventData = merge(this.contextualEventData, {
                event: {
                    environment: {
                        featureAppId: this.featureApp.trackingId
                    }
                }
            });
            this.delegate.track(action, event, newContextualEventData);
        }
        else {
            this.delegate.track(action, event, this.contextualEventData);
        }
    }
}
function createFullContextualData(contextualData) {
    if (contextualData && (contextualData === null || contextualData === void 0 ? void 0 : contextualData.featureAppId)) {
        return merge(contextualData, {
            event: { environment: { featureAppId: contextualData.featureAppId } }
        });
    }
    return contextualData;
}
